import script from "./FileFolder.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileFolder.vue?vue&type=script&setup=true&lang=ts"

import "./FileFolder.vue?vue&type=style&index=0&id=43762bc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43762bc0"]])

export default __exports__